import { NitroText } from 'nitro-components';
import styled from 'styled-components';

import React, { PropTypes } from 'react';

import { DriverAvatar } from '../../../components/driver';
import {
  RegoPlate
  // , VehicleAvatar
} from '../../../components/vehicle';
import Bookmark from './Bookmark';
import HeaderStuds from './HeaderStuds';
import SafteyRating from './SafteyRating';

const Container = styled.div`
  position: absolute;
  min-width: 520px;
  max-width: 1000px;
  right: 0;
  left: 0;
  margin: auto;
  top: 16px;
  text-align: center;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const HeadingSection = styled.div`
  display: flex;
  flex-direction: row; /* make main axis vertical */
  justify-content: center; /* center items vertically, in this case */
  align-items: center;
  padding-top: ${props => props.paddingTop};
  padding-bottom: 0px;
  width: 50%;
`;

const HeadingText = styled.span`
  color: #ffffff;
  font-family: noto-sans-bold;
  opacity: 1;
  font-size: 28px;
  max-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
`;

const ProfileHeading = props => {
  const {
    title,
    bookmarkClick,
    bookmarkActive,
    studs,
    subTitle,
    onStudClick,
    dashboardType,
    avatar,
    paddingTop
  } = props;
  return (
    <Container dashboardType={dashboardType}>
      <HeadingSection dashboardType={dashboardType} paddingTop="0">
        {/* {dashboardType !== 'driver' ? (
          <VehicleAvatar
            padding={10}
            width={80}
            height={80}
            varaint="white"
            imageKey={avatar}
            horizontal
            horizontalImgWidthPercentage="100"
          />
        ) : (
          ''
        )} */}
        <div>
          <HeadingText>{title}</HeadingText>
          {dashboardType === 'driver' ? (
            <div />
          ) : (
            <RegoPlate value={subTitle} active />
          )}
        </div>

        <Bookmark
          left={20}
          onClick={bookmarkClick}
          active={bookmarkActive}
          variant={dashboardType === 'driver' ? 'secondary' : 'primary'}
        />
      </HeadingSection>

      <HeadingSection dashboardType={dashboardType} paddingTop="0px">
        <HeaderStuds
          dashboardType={dashboardType}
          studs={studs}
          top={10}
          left={10}
          onStudClick={onStudClick}
        />
      </HeadingSection>
    </Container>
  );
};

ProfileHeading.propTypes = {
  title: PropTypes.string,
  bookmarkClick: PropTypes.func,
  bookmarkActive: PropTypes.bool,
  subTitle: PropTypes.string,
  studs: PropTypes.array,
  onStudClick: PropTypes.func,
  dashboardType: PropTypes.string,
  avatar: PropTypes.string,
  paddingTop: PropTypes.string
};

ProfileHeading.defaultProps = {
  // defaultProp: ''
};

export default ProfileHeading;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileHeading.js